export default class TopBar {
  constructor(dom) {
    this.dom = dom;
    this.initList();
    window.addEventListener("resize", () => this.resize());
  }

  initList() {
    const topbar = document.querySelector("[js-top-bar]");
    if (topbar) {
      topbar.addEventListener("click", () => {
        // console.log("click");
        if (!topbar) return;
        toggleList(topbar);
        changeText(topbar);
      });
      function toggleList(list) {
        const button = list.querySelector("[js-top-bar-button]");
        const listIsOpened = button.getAttribute("aria-expanded");

        if (listIsOpened === "true") {
          list
            .querySelector("[js-top-bar-button]")
            .setAttribute("aria-expanded", false);

          list
            .querySelector("[js-top-bar-list]")
            .setAttribute("aria-hidden", true);
        } else {
          list
            .querySelector("[js-top-bar-button]")
            .setAttribute("aria-expanded", true);

          list
            .querySelector("[js-top-bar-list]")
            .setAttribute("aria-hidden", false);
        }
      }

      function changeText(list) {
        const items = list.querySelectorAll(".m-t-select--item");
        const button = list.querySelector("[js-top-bar-button]");
        const label = button.querySelector("h4");
        // console.log(label);
        // console.log(items);
        for (let item of items) {
          item.addEventListener("click", (e) => {
            items.forEach(function (el) {
              el.classList.remove("active");
            });
            e.target.classList.add("active");
            label.textContent = e.target.dataset.item;
          });
        }
      }
    }
  }

  resize() {
    // console.log("resize from Navigation.js");
  }
}
